function generateId(prefix = 'rnd-id', maxIndex = 1000) {
  return (prefix + Math.random() * maxIndex).replace('.', '-');
}

export { generateId };
